const screenSizes = {
  smallMobile: 320,
  mobile: 480,
  tablet: 800,
  minitablet: 600,
  desktop: 1024,
  mediumDesktop: 1280,
  semiLargeDesktop: 1366,
  largeDesktop: 1440,
  hugeDesktop: 1680,
  extraLargeDesktop: 1920,
};

export const {
  smallMobile,
  mobile,
  tablet,
  minitablet,
  desktop,
  mediumDesktop,
  semiLargeDesktop,
  largeDesktop,
  hugeDesktop,
  extraLargeDesktop,
} = screenSizes;
